export default __webpack_public_path__ + "static/media/twitter.e40fe468.svg";